export enum AppEventType {
    ClickedOnNotification = 'CLICKED_ON_NOTIFICATION'
}